import styled from "styled-components";
import { SignupContainer, SignupWrapper } from "../signup/signup.style";

export const ResetPasswordContainer = styled(SignupContainer)``;

export const ResetPasswordWrapper = styled(SignupWrapper)``;
